<template>
  <div class="p-2">
    <small class="text-secondary">build at: {{ buildAt }}</small>
  </div>
</template>

<style lang="scss" scoped>

</style>

<script setup lang="ts">
  import {DateTime} from "luxon";

  const buildAt = DateTime.fromISO("2025-10-15T03:00:00.000Z").toFormat("yyyy-MM-dd HH:mm");
</script>
